import { render, staticRenderFns } from "./LucroComponentesDeSeuCalculo.vue?vue&type=template&id=4e646448&scoped=true&"
import script from "./LucroComponentesDeSeuCalculo.vue?vue&type=script&lang=js&"
export * from "./LucroComponentesDeSeuCalculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e646448",
  null
  
)

export default component.exports